/**
 * Hook для доступа к системным настройкам (кэшируется React Query).
 * Используется в первую очередь для получения pilot_display_mode и airport_display_mode.
 */
import { useQuery } from '@tanstack/react-query';
import { getSystemSettings, type SystemSettingsData } from '@/api/endpoints';
import type { PilotDisplayMode } from '@/utils/formatPilot';
import type { AirportDisplayMode } from '@/utils/formatAirport';

export function useSystemSettings() {
  return useQuery<SystemSettingsData>({
    queryKey: ['systemSettings'],
    queryFn: getSystemSettings,
    staleTime: 5 * 60 * 1000, // 5 минут — настройки меняются редко
    retry: 1,
  });
}

/** Удобный хук — возвращает только режим отображения пилотов. */
export function usePilotDisplayMode(): PilotDisplayMode {
  const { data } = useSystemSettings();
  return (data?.pilot_display_mode as PilotDisplayMode) || 'name';
}

/** Удобный хук — возвращает только режим отображения аэропортов. */
export function useAirportDisplayMode(): AirportDisplayMode {
  const { data } = useSystemSettings();
  return (data?.airport_display_mode as AirportDisplayMode) || 'icao';
}
